import React, { Fragment } from 'react';
import Loader from 'components/sales/Loader/loader';

const PanelCardWithHeading = ({ children, title, isLoading = false ,colorChange=null,status=null}) => {
  return (
    <Fragment>
      <div className="panel-card">
        <div className="panel-heading">{title} 
        {status ?
        <span className='pending status-td' style={{'color':'#ffdd9e'}}>{status}</span>
        : null}
        
        </div>
        <div className="panel-body" style={colorChange ? {'background-color' : '#fff3f3'} : null}>{children}</div>
      </div>
      <Loader isLoading={isLoading} />
    </Fragment>
  );
};

export default PanelCardWithHeading;
